export const formatSinal = (value) => {
    if (value === null || value === undefined || value === "") {
        return ""
    }

    const sinais = {
        "+": "+ (Positivo)",
        "-": "- (Negativo)",
    }

    return sinais[value] ?? value
}